/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import StyledPaymentSetup from "./StyledPaymentSetup";
import { Box, Button, Typography } from "@mui/material";
import paymentCard from "../../assets/images/payment-card-img.svg";
import { BUTTON_LABELS } from "../../constants/lang";
import { fetchConnectStripe } from "../../store/reducers/createProfile";
import { useDispatch, useSelector } from "react-redux";
import { updateLoading } from "../../store/reducers/loader";
import rollbar from "../../rollbarConfig";

const PaymentSetup = () => {
  const dispatch = useDispatch();
  const profileData = useSelector((state) => state?.createProfile?.userProfile);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const connectStipe = async () => {
    dispatch(updateLoading(true));
    try {
      const res = await dispatch(fetchConnectStripe());
      const { status, message, data } = res?.payload || {};
      if (status) {
        window.location.href = data;
        localStorage.setItem("createProfilePayment", true);
      } else {
        console.error("API error: ", message);
        dispatch(updateLoading(false));
      }
    } catch (err) {
      rollbar.error("Error message", err);
      console.error(err);
      dispatch(updateLoading(false));
    }
  };

  return (
    <StyledPaymentSetup>
      <Box className='payment-setup-header'>Payment Setup</Box>
      <Box className='payment-setup-wrap'>
        <Box className='payment-setup-body'>
          <Typography className='payment-body-header'>
            Payment Setup Stripe
          </Typography>
          {profileData?.stripe_connect_details === null ? (
            <Typography className='payment-body-text'>
              To receive payouts for your sales, securely link your bank account
              or eligible debit card with Stripe by following the steps below.
            </Typography>
          ) : (
            <Box className='account-details-wrap'>
              <Box className='account-deatils'>
                <Typography className='account-name'>
                  {profileData?.stripe_connect_details?.bank_name}
                </Typography>
                <Box className="account-deatils-line"></Box>
                <Box className='account-number'>
                  <Typography className='account-number-text'>{`••••  ••••  ••••  ${profileData?.stripe_connect_details?.bank_account_last_four_digit}`}</Typography>
                </Box>
              </Box>
              <Box className='account-success'>
                <Typography className='success-text'>
                  Your payment setup is complete! You can now receive payouts to your selected method.
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
        <Box className='payment-setup-image'>
          <img src={paymentCard} alt='payment card' className='payment-card' />
        </Box>
      </Box>
      <Box>
        {profileData?.stripe_connect_details === null ? (
          <Button
            variant='contained'
            color='primary'
            // isLoading={isLoading}
            // disabled={isLoading}
            aria-label='submit-btn'
            className='submit-btn'
            onClick={() => connectStipe()}
          >
            {BUTTON_LABELS.CONNECT_STRIPE}
          </Button>
        ) : (
          ""
        )}
      </Box>
    </StyledPaymentSetup>
  );
};

export default PaymentSetup;
